import(/* webpackMode: "eager" */ "/vercel/path0/src/app/history/page.tsx");
